import { createSelector } from 'reselect';
import { StoreState } from 'src/store/reducers';
import { IProvider } from 'src/types/provider';
import { SelectableItem } from 'src/enumerables/enumerable.abstract';
import { selectNameSerTypes } from './service-types-selectors';
import { selectNameSerLocations } from './service-location-selectors';

import { Paginated } from '../../services/api-handlers/pagination';

export const Selector = (state: StoreState) => state.providers.data.list;
export const SelectorAndState = (state: StoreState) => ({ providers: state.providers.data, state });
export const mappedStaffSelector = createSelector(Selector, (staff: IProvider[]): SelectableItem[] =>
    staff.map((item: IProvider) => ({ name: item.fullName, value: item.id })),
);
export const miniLoaderForSelector = (state: StoreState) => state.providers.miniLoaderFor;
export const selectNameProviders = createSelector(Selector, (items): {
    label: string;
    value: number | string;
    annualSalary: number;
}[] => {
    const arrSel: { label: string; value: number | string; annualSalary: number }[] = [];
    if (items) {
        items.forEach((item: IProvider) => {
            arrSel.push({ label: item.fullName, value: item.id, annualSalary: item.annualSalary });
        });
        arrSel.sort(
            (
                a: { label: string; value: number | string; annualSalary: number },
                b: { label: string; value: number | string; annualSalary: number },
            ) => {
                const textA = a.label && a.label.toUpperCase();
                const textB = b.label && b.label.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            },
        );
    }

    return arrSel;
});
export const selectTitleProviders = createSelector(Selector, (items): { title: string; id: number | string }[] => {
    const arrSel: { title: string; id: number | string }[] = [];

    items.forEach((item: IProvider) => {
        arrSel.push({ title: item.fullName, id: item.id });
    });

    return arrSel;
});
export const selectProviders = createSelector(
    SelectorAndState,
    ({ state, providers }: { providers: Paginated<IProvider>; state: StoreState }): Paginated<Partial<IProvider>> => {
        const namesSerTypes = selectNameSerTypes(state);
        const namesSerLocations = selectNameSerLocations(state);

        const providersList: Partial<IProvider>[] = providers.list.map((item: IProvider) => {
            let serviceLocationsValues: any = [];
            let serviceTypesValues: any = [];
            if (item.userServiceLocations) {
                item.userServiceLocations.forEach((itData: any) => {
                    serviceLocationsValues.push(namesSerLocations[itData.serviceLocation.id]);
                });
            }
            if (item.userServiceTypes) {
                item.userServiceTypes.forEach((itData: any) => {
                    serviceTypesValues.push(namesSerTypes[itData.serviceType.id]);
                });
            }

            serviceTypesValues = serviceTypesValues.join(',');
            serviceLocationsValues = serviceLocationsValues.join(',');

            const retProvider: Partial<IProvider> = {
                fullName: item.fullName,
                email: item.email,
                phone: item.phone,
                serviceLocations: serviceLocationsValues,
                serviceTypes: serviceTypesValues,
                npi: item.npi,
                license: item.license,
                licenseDescription: item.licenseDescription,
                sessionConfirmAlert: item.sessionConfirmAlert,
                sessionConfirmPercentage: item.sessionConfirmPercentage,
                sessionConfirmedInTimeSessionByNow: item.sessionConfirmedInTimeSessionByNow,
                sessionScheduledByNow: item.sessionScheduledByNow,
                isGetAdvance: item.isGetAdvance,
                creationDate: item.creationDate,
                status: item.status,
                createdAt: item.createdAt,
                id: item.id,
                supervisor: item.supervisor,
            };
            return retProvider;
        });

        return { ...providers, list: providersList };
    },
);
